import translations from '../../components/location/ts/en-CA';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('en-CA', translations);
